import type {Size2Like} from "@cm/math"

export function getNumFloorMipLevels(size: Size2Like) {
    if (size.width <= 0 || size.height <= 0) {
        return 0 // no mipmaps for empty images
    }
    return Math.floor(Math.log2(Math.max(size.width, size.height))) + 1
}

export function getNumCeilMipLevels(size: Size2Like) {
    if (size.width <= 0 || size.height <= 0) {
        return 0 // no mipmaps for empty images
    }
    return Math.ceil(Math.log2(Math.max(size.width, size.height))) + 1
}

export const getMipLevelBiasScale = (mipLevelBias: number): number => {
    if (mipLevelBias > 0) {
        return 1 / (1 << mipLevelBias)
    } else {
        return 1 << -mipLevelBias
    }
}

export const getMipLevelSize = (fullSize: Size2Like, mipLevel: number, options?: {useCeilSize?: boolean}): Size2Like => {
    const useCeilSize = options?.useCeilSize ?? true
    const mipScale = getMipLevelBiasScale(mipLevel)
    const mipLevelSize = {
        width: fullSize.width * mipScale,
        height: fullSize.height * mipScale,
    }
    if (useCeilSize) {
        mipLevelSize.width = Math.ceil(mipLevelSize.width)
        mipLevelSize.height = Math.ceil(mipLevelSize.height)
    }
    return mipLevelSize
}
